import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactElement } from 'react';
import { Color } from 'shared/utils/colors';

// `CloudUpload` cuts the arrow out of the cloud; here the arrow is its own
// filled path so it can take a different color than the cloud.
const CLOUD_PATH =
  'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z';
const ARROW_PATH = 'M14 13v4h-4v-4H7l5-5 5 5z';

/** Cloud upload icon: brand-yellow cloud (`Color.primaryOrange`), black up arrow. */
export function UploadFromDeviceIcon(props: SvgIconProps): ReactElement {
  return (
    <SvgIcon {...props}>
      <path d={CLOUD_PATH} fill={Color.primaryOrange} />
      <path d={ARROW_PATH} fill={Color.black} />
    </SvgIcon>
  );
}
